import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function PrivateRoute({ component }) {
  const { isAuthenticated } = useAuth();
  // console.log("PrivateRoute", isAuthenticated);
  const location = useLocation();

  // Never send the patient back to /myprofile after logging in — but do it
  // without mutating the router's own location object, which leaked into the
  // history entry and bounced later navigations home.
  const from =
    location.pathname === "/myprofile" ? { ...location, pathname: "/" } : location;

  // Redirect them to the /login page, but save the current location they were
  // trying to go to when they were redirected. This allows us to send them
  // along to that page after they login, which is a nicer user experience
  // than dropping them off on the home page.
  // return component;
  return isAuthenticated ? (
    component
  ) : (
    <Navigate to="/login" replace state={{ from }} />
  );
}
